import styled,{keyframes} from 'styled-components'


export const SpinnerContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction:column;
    img {
        width: 217px;
        height: 217px;
    }  
`

export const CirclesContainer = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
`

export const skBouncedelay = keyframes`
    0%, 80%, 100% { 
        transform: scale(0.4);
    } 40% { 
        transform: scale(1.0);
  }
`
type TypeColor = {
    color:string,
    size?: string
}
export const Circle = styled.div<TypeColor>`
    width: ${props => props.size ? props.size : '48px'};
    height: ${props => props.size ? props.size : '48px'};
    margin: ${props => props.size === '48px' ? '15px': '0px 5px'};
    border-radius: 100% !important;
    display: inline-block;
    animation: ${skBouncedelay} 1.0s infinite ease-in-out both;
`

export const CircleOne = styled(Circle)<TypeColor>`
    background-color:${(props) =>`${props.color}`};
    animation-delay: -0.32s;
`

export const CircleTwo = styled(Circle)<TypeColor>`
    background-color:${(props) =>`${props.color}`};
    animation-delay: -0.16s;
`

export const CircleThree = styled(Circle)<TypeColor>`
    background-color:${(props) =>`${props.color}`};
`

